import { MailOutboxPreview } from "./MailOutboxPreview";
import { MailTestPanel } from "./MailTestPanel";

export function NotificationAdminPanels() {
  return (
    <div className="grid gap-4 xl:grid-cols-[minmax(0,1fr)_minmax(360px,460px)]">
      <MailTestPanel />
      <MailOutboxPreview />
    </div>
  );
}
